import { Box, Group, Text } from '@mantine/core'

export type WsStatus = 'connected' | 'reconnecting' | 'disconnected'

const STATUS_CONFIG: Record<WsStatus, { color: string; label: string }> = {
  connected:    { color: 'green',  label: 'Conectado' },
  reconnecting: { color: 'yellow', label: 'Reconectando' },
  disconnected: { color: 'red',    label: 'Desconectado' },
}

interface WhatsApiWsIndicatorProps {
  status: WsStatus
  lastEventAt?: Date | null
}

export function WhatsApiWsIndicator({ status, lastEventAt }: WhatsApiWsIndicatorProps) {
  const config = STATUS_CONFIG[status]
  const title = lastEventAt
    ? `${config.label} - Último evento: ${lastEventAt.toLocaleTimeString()}`
    : config.label

  return (
    <Group gap="xs" title={title} aria-label={title} role="status">
      <Box
        data-testid="ws-indicator-dot"
        data-status={status}
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: `var(--mantine-color-${config.color}-6)`,
          animation: status === 'connected' ? 'wsPulse 2s ease-in-out infinite' : undefined,
        }}
      />
      <Text size="xs" c="dimmed">{config.label}</Text>
    </Group>
  )
}
